import { InjectionToken } from '@angular/core';
import { PageEditDialogService } from './components/page-edit-screen/page-edit-dialog.service';

export const CONTENT_PAGE_DIALOG_SERVICE_TOKEN = new InjectionToken<PageEditDialogService>('ContentPageDialogService');
export const REDEEM_PAGE_DIALOG_SERVICE_TOKEN = new InjectionToken<PageEditDialogService>('RedeemPageDialogService');
